export default __webpack_public_path__ + "static/media/share_icon.bffa40ef.svg";